import URI from 'urijs';
import moment from 'moment';

var GMS = window.GMS;
const delayBeforeCheck = 45;

function getUserToken() {
    if (window.GMS) return window.GMS.infos.getUserToken();
    return null;
}

function addTokenEvent(selector = ""){
    $(document).on('click', 'a.js-reservation-link,a[href*="reservations.travelclick.com"]' + selector, function () {
        const gmsToken = getUserToken();
        if (gmsToken) {
            let bookingLink = new URI(this.href);
            let additionalParams = {};

            if (gmsToken)
                additionalParams['token'] = gmsToken;

            bookingLink.setQuery(additionalParams);
            this.href = bookingLink.href();
        }
    });
}

function gmsColorize(color) {
    $('.js-gms-tier-background').css('backgroundColor', color);
}

function initGMS() {
    function gmsConnectCheck() {
        new Promise(function (resolve, reject) {
            // try/catch because JSON.parse can cause an error if the json is invalid
            try {
                if (localStorage.getItem("gms_profil_data")) {
                    var gmsData = JSON.parse(localStorage.getItem("gms_profil_data"))
                    if (gmsData && gmsData.firstName && gmsData.timestamp) {
                        // check if it's been less than X min before last localstorage update
                        if (getMinutesDifference(+new Date(), gmsData.timestamp) < delayBeforeCheck) resolve(gmsData)
                    }
                }
                reject();
            } catch (e) {
                reject(e)
            }
        }).then(function (gmsData) {
            let optionsWithNumber = ['points', 'nights', 'stays','cashValue']

            optionsWithNumber.forEach(function (name) {
                let currentVal = gmsData[name] || 0;

                $(`.js-gms-${name}`).text(currentVal);
                $(`.js-gms-${name}-text`).text(function () {
                    if (currentVal == 1) return $(this).data('singular');
                    return $(this).data('plural');
                });
            });

            $('.js-gms-fullname').text(gmsData.firstName);
            $('.js-gms-firstname').text(gmsData.firstName);
            $('.js-gms-lastname').text(gmsData.lastName);
            $('.js-gms-tier').text(gmsData.levelName || '');

            gmsColorize(gmsData.levelColor);

            $('body').addClass('gms-connected');

            if (gmsData.birthdayInfo && gmsData.birthdayInfo.nbDaysBeforeNext === 0) {
                $('.js-gms-show-on-birthday').removeClass('hidden');
                $('.js-gms-hide-on-birthday').addClass('hidden');
            }

            if (document.querySelector('.js-gms-replace-reservation')) {
                try {
                    const resInformation = JSON.parse(localStorage.getItem('current_res'));
                    if (resInformation) {
                        $('.js-gms-replace-reservation').text((index, text) => {
                            return text
                                .replace('{hotel}', resInformation.hotel)
                                .replace('{date}', moment(resInformation.checkInDate, 'YYYY-MM-DD').format(window.gmsDateFormat));
                        }).removeClass('hidden');
                        $('.js-gms-hide-if-reservation').addClass('hidden');
                    }
                } catch (error) {
                    console.error(error);
                }
            }
        }).catch(function () {
            $('body').removeClass('gms-connected');
        })

        $(document).on('click', '.js-gms-logout-action', function (e) {
            e.preventDefault();

            GMS.actions.callbacks.clearToken();
            GMS.actions.callbacks.logout();
            localStorage.removeItem("gms_profil_data")
            localStorage.removeItem("current_res")
            if (window.GMS_required_status == 'auth') {
                if (window.gmsLoginURL) document.location = window.gmsLoginURL;
            } else {
                $(document).trigger("gmsProfilData");
            }

            $(document).trigger('GMS_not-connected');
        })
    }


    gmsConnectCheck()

    $(document).on('gmsProfilData', function () {
        gmsConnectCheck();
    })
}

/* Returns minutes differences between 2 dates */
function getMinutesDifference(date1, date2) {
    return ((date1 - date2) / 1000) / 60
}

export default initGMS;
export { getUserToken };
